module.exports = __webpack_public_path__ + "media/images/Rectangle-f15a13c4835987d896c0a69755417486.png";